import {
  SALON_LOGIN_EXPIRES_AT_KEY,
  SALON_LOGIN_TIMEOUT_MINUTES_KEY,
  SALON_LAST_ACTIVITY_AT_KEY,
} from '../config/salonApp';

export const DEFAULT_SALON_IDLE_TIMEOUT_MINUTES = 15;

export function getSalonIdleTimeoutMs() {
  try {
    const raw = sessionStorage.getItem(SALON_LOGIN_TIMEOUT_MINUTES_KEY);
    const minutes = Number.parseInt(String(raw || ''), 10);
    if (Number.isFinite(minutes) && minutes > 0) {
      return minutes * 60 * 1000;
    }
  } catch (_) {}
  return DEFAULT_SALON_IDLE_TIMEOUT_MINUTES * 60 * 1000;
}

export function setSalonLoginTimeoutMinutes(minutes) {
  const value = Number.parseInt(String(minutes || ''), 10);
  if (!Number.isFinite(value) || value <= 0) return;
  try {
    sessionStorage.setItem(SALON_LOGIN_TIMEOUT_MINUTES_KEY, String(value));
  } catch (_) {}
}

function extendLocalSessionExpiry(nowMs = Date.now()) {
  const expiresAt = new Date(nowMs + getSalonIdleTimeoutMs()).toISOString();
  try {
    sessionStorage.setItem(SALON_LOGIN_EXPIRES_AT_KEY, expiresAt);
  } catch (_) {}
  return expiresAt;
}

/**
 * Record user interaction or successful API activity; resets idle logout timer.
 */
export function recordSalonUserActivity(nowMs = Date.now()) {
  try {
    sessionStorage.setItem(SALON_LAST_ACTIVITY_AT_KEY, String(nowMs));
  } catch (_) {}
  return extendLocalSessionExpiry(nowMs);
}

export function getSalonLastActivityMs() {
  try {
    const raw = sessionStorage.getItem(SALON_LAST_ACTIVITY_AT_KEY);
    const parsed = Number.parseInt(String(raw || ''), 10);
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
  } catch (_) {}

  try {
    const expiresRaw = sessionStorage.getItem(SALON_LOGIN_EXPIRES_AT_KEY);
    const expiresMs = Date.parse(String(expiresRaw || ''));
    if (Number.isFinite(expiresMs)) {
      return expiresMs - getSalonIdleTimeoutMs();
    }
  } catch (_) {}

  return Date.now();
}

export function isSalonSessionIdleExpired(nowMs = Date.now()) {
  const lastActivity = getSalonLastActivityMs();
  return nowMs - lastActivity >= getSalonIdleTimeoutMs();
}

export function applyServerSessionExpiry(sessionExpiresAt) {
  const raw = String(sessionExpiresAt || '').trim();
  if (!raw) return;
  try {
    sessionStorage.setItem(SALON_LOGIN_EXPIRES_AT_KEY, raw);
    const expiresMs = Date.parse(raw);
    if (Number.isFinite(expiresMs)) {
      const lastActivity = expiresMs - getSalonIdleTimeoutMs();
      sessionStorage.setItem(SALON_LAST_ACTIVITY_AT_KEY, String(lastActivity));
    }
  } catch (_) {}
}
